import dateUtils from "@/utils/dateUtils";
import netWorkController from "@/http/netWorkController";
import toastUtils from "@/utils/toastUtils";
import ToastUtils from "@/utils/toastUtils";
import consoleLog from "@/utils/consoleLog";
import logLevelUtils from "@/utils/logLevelUtils";

export default {
    name: "OnlineLogPage",
    data() {
        return {
            logSwitchEnums: {OPEN: '1', CLOSED: '2'},
            logLevel: logLevelUtils.logLevelList(),
            //在线日志请求体
            request: {
                //在线日志开始时间，id为-1的时候，使用此条件查询在线日志
                logBeginTime: null,
                //id不等于-1，查询此id之后的在线日志
                id: -1,
                logLevel: -1
            },
            device: {},
            logSwitchState: false,
            beginTimeStr: '',
            //日志获取定时器
            onlineLogTimer: null,
            //在线日志开关状态维持定时器
            logSwitchStateTimer: null,
            autoScroll: true,
            noDataTips: false,
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.onscroll()
        })
    },
    created() {
        let data = {}
        data.id = this.$route.query.deviceId;
        data.appId = this.$route.query.appId;
        this.request.appId = data.appId
        const userInfoStr = window.localStorage.getItem("userInfo")
        if (userInfoStr) {
            let userInfo = JSON.parse(userInfoStr)
            this.request.userId = userInfo.id
            data.userId = userInfo.id;
            data.accessToken = userInfo.accessToken;
        }
        // 离开当前页面时销毁定时器
        this.$once('hook:beforeDestroy', () => {
            this.closeLogSwitchTimer()
            this.closeOnlineLogTimer()
        })

        netWorkController.getDeviceById(data, (result) => {
            if (result.status === 200) {
                this.device = result.data
                this.request.deviceCode = this.device.deviceCode
                this.getSwitchLogStatus()
                if (Date.now() - this.device.lastHeartTime > 1000 * 60 * 3) {
                    ToastUtils.warning(this, '当前设备不在线，可能无法及时获取在线日志！')
                }
            } else {
                toastUtils.warning(this, result.msg)
            }
        })
    },
    methods: {
        onChange(value) {
            if (value) {
                ///日志等级筛选
                this.request.id = -1;
                this.clearList()
                this.getOnLineLog()
            }
        },
        clearLogDataClick() {
            this.beginTimeChange();
            this.clearList()
        },
        onSwitchClick(value) {
            let messageContent = this.logSwitchEnums.CLOSED
            if (value) {
                this.beginTimeChange();
                messageContent = this.logSwitchEnums.OPEN
                this.startOnlineLogTimer()
            }
            this.setSwitchLogStatus(messageContent);
        },
        //初始化日志开始时间
        beginTimeChange() {
            let timestamp = Date.now()
            this.request.logBeginTime = timestamp;
            this.beginTimeStr = dateUtils.timestampToDate(timestamp)
        },
        getSwitchLogStatus() {
            netWorkController.getSwitchOnlineLogStatus(this.device, (result) => {
                if (result.status === 200) {
                    this.logSwitchState = result.data === this.logSwitchEnums.OPEN
                    if (this.logSwitchState === true) {
                        this.beginTimeChange()
                        this.getOnLineLog()
                        this.setSwitchLogStatus(this.logSwitchEnums.OPEN)
                    }
                } else {
                    toastUtils.warning(this, result.msg)
                }
            })
        },
        setSwitchLogStatus(messageContent) {
            let data = {}
            data.deviceCode = this.device.deviceCode;
            data.deviceOwner = this.device.deviceOwner;
            data.appId = this.device.appId;
            data.messageContent = messageContent
            netWorkController.setSwitchOnlineLog(data, (result) => {
                if (result.status === 200) {
                    if (messageContent === this.logSwitchEnums.OPEN) {
                        this.startLogSwitchTimer()
                    } else {
                        this.closeLogSwitchTimer()
                    }
                } else {
                    toastUtils.warning(this, result.msg)
                }
            })
        },
        //获取在线日志
        getOnLineLog() {
            if (this.logSwitchState === false) {
                return;
            }
            netWorkController.listOnLineLog(this.request, (result) => {
                if (result.status === 5001) {
                    this.logSwitchState = false;
                    this.closeLogSwitchTimer()
                    toastUtils.warning(this, result.msg())
                    return;
                }
                if (this.logSwitchState === true) {
                    this.startOnlineLogTimer()
                }
                if (result.status === 200) {
                    this.appendLogList(result.data);
                } else {
                    toastUtils.warning(this, result.msg)
                }
            })
        },
        //在线日志列表数据追加
        appendLogList(list) {
            const logList = document.getElementById('logList')
            if (this.noDataTips === true) {
                this.noDataTips = false;
            }
            if (list === null || list.length <= 0) {
                if (!logList.hasChildNodes()) {
                    this.noDataTips = true;
                }
                return
            }
            list = list.reverse()
            this.request.id = list[list.length - 1].id
            for (let i = 0; i < list.length; i++) {
                const bean = list[i]
                const logLevelTips = logLevelUtils.logLevelExchange(bean.logLevel)
                let textColor = logLevelUtils.logLevelColorExchange(bean.logLevel)
                const uploadTime = dateUtils.timestampToDate(bean.uploadMilli)
                let content = bean.logContent
                //判断返回内容是否保护html标签
                if (bean.logContent.indexOf("<html") !== -1) {
                    content = this.he.encode(bean.logContent)
                }
                const li = document.createElement('li')
                li.innerHTML = '<div style="display:inline-flex;border-bottom:1px solid ' + textColor + ';width: 100%;padding:10px 0;align-items: center;color: ' + textColor + '">' +
                    '<div style="width: 15%;text-align: center;align-items: center;">' + logLevelTips + '</div>' +
                    '<div style="width: 15%;text-align: center;align-items: center;">' + uploadTime + '</div>' +
                    '<div style="width: 70%;text-align: center;align-items: center;white-space: pre-wrap;word-break: break-all;">' + content + '</div>' +
                    '</div>'
                logList.appendChild(li)
            }
            // 自动滚动到底部
            if (this.autoScroll) {
                logList.scrollTop = logList.scrollHeight
            }
            if (!logList.hasChildNodes()) {
                this.noDataTips = true;
            }
        },
        clearList() {
            const logList = document.getElementById('logList')
            if (logList.hasChildNodes()) {
                logList.innerHTML = ''
            }
        },
        //列表滚动监听和动态设置列表高度
        onscroll() {
            //浏览器的总高度
            const visibleHeight = window.innerHeight;
            const mainTitleHeight = document.getElementById('mainTitle').clientHeight
            const formHeight = document.getElementById('form').clientHeight
            const logTitleHeight = document.getElementById('logTitle').clientHeight
            //30：<el-form>标签的margin值，10：抛开10像素
            const diffHeight = visibleHeight - mainTitleHeight - formHeight - logTitleHeight - 30 - 10;
            let percent = Math.ceil((diffHeight / visibleHeight) * 100);
            consoleLog.log("visibleHeight:" + visibleHeight + ",diffHeight:" + diffHeight + ",percent:" + percent)
            const logList = document.getElementById('logList')
            //动态设置日志列表的高度
            logList.style.height = percent + "%";
            logList.onscroll = () => {
                const scrollHeight = logList.scrollHeight // 整个列表内容的高度
                const scrollTop = logList.scrollTop // 滚动距离
                const offsetHeight = logList.offsetHeight // logList固定的显示高度
                // 抛10px的误差
                this.autoScroll = (scrollTop + offsetHeight + 10) >= scrollHeight
            }
        },
        //（定时器）3秒一次获取在线日志
        startOnlineLogTimer() {
            this.closeOnlineLogTimer()
            this.onlineLogTimer = setTimeout(() => {
                this.onlineLogTimer = null
                this.getOnLineLog()
            }, 3000)
        },
        //取消日志获取定时器
        closeOnlineLogTimer() {
            if (this.onlineLogTimer) {
                clearTimeout(this.onlineLogTimer)
            }
        },
        //定时5分钟设置在线日志开关状态
        startLogSwitchTimer() {
            this.closeLogSwitchTimer()
            // 后台日志上传6分钟会自动关闭，再5分钟发送开启状态，保持状态。
            this.logSwitchStateTimer = setTimeout(() => {
                this.logSwitchStateTimer = null
                this.setSwitchLogStatus(this.logSwitchEnums.OPEN)
            }, 1000 * 60 * 5)
        },
        //取消开关状态维持定时器
        closeLogSwitchTimer() {
            if (this.logSwitchStateTimer) {
                clearTimeout(this.logSwitchStateTimer)
            }
        },

    }
}